export default __webpack_public_path__ + "static/media/requestAttendanceSquare.d5355f22.svg";